import React from 'react';
import { styled } from '@mui/material/styles';
import { IconButton, Typography } from '@mui/material';

const LogoButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: '#00a651',
  color: '#fff',
  borderRadius: '12px',
  width: '40px',
  height: '40px',
  marginRight: theme.spacing(1),
  fontWeight: 'bold',
  fontSize: '14px',
}));

const Logo: React.FC = () => {
  return (
    <LogoButton>
      <Typography variant="body2" fontWeight="bold">
        SA
      </Typography>
    </LogoButton>
  );
};

export default Logo;
